<template>
  <div>
    <!-- <rabbey-toolbox
      filter-placeholder="Buscar por nombre"
      filterables
      @filter-search="search = $event"
    /> -->

    <div>
      <el-select
        v-if="
          options == 'chartyer' ||
          options == 'chartdia' ||
          options == 'hor' ||
          options == 'min'
        "
        v-model="year"
        size="mini"
        placeholder="años"
        clearable
        filterable
        @change="handlerYearChange"
      >
        <el-option
          v-for="year in yearsearch"
          :key="year.value"
          :label="year.label"
          :value="year.value"
        >
        </el-option>
      </el-select>

      <el-select
        v-if="options == 'hor' || options == 'min'"
        v-model="dia"
        size="mini"
        placeholder="Dias"
        clearable
        filterable
      >
        <el-option
          v-for="dia in dias"
          :key="dia.Value"
          :label="dia.Label"
          :value="dia.Value"
        >
        </el-option>
      </el-select>

      <el-time-select
        v-if="options == 'min' && options != 'hor'"
        v-model="valueH"
        size="mini"
        format="HH"
        :picker-options="{
          start: '00:00',
          end: '23:59'
        }"
        placeholder="Seleccione la Hora"
      >
      </el-time-select>

      <el-select
        v-if="options == 'chartdia' || options == 'hor' || options == 'min'"
        v-model="mes"
        size="mini"
        placeholder="meses"
        clearable
        filterable
      >
        <el-option
          v-for="mes in meses"
          :key="mes.Value"
          :label="mes.Label"
          :value="mes.Value"
        >
        </el-option>
      </el-select>

      <el-select
        v-show="activeName == 'TransactionReport'"
        v-model="declinedOption"
        size="mini"
        :loading="loading_transaction_report"
        filterable
        clearable
        placeholder="Filtro declinadas"
        @change="onDeclinedChanging"
      >
        <el-option
          v-for="(item, index) in declinedOptions"
          :key="index"
          :label="item.label"
          :value="item.value"
        >
        </el-option
      ></el-select>
    </div>

    <div
      style="
        background-color: white;
        margin-top: 10px;
        box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
        padding: 20px;
      "
    >
      <el-tabs v-model="activeName" @tab-click="switchtabs">
        <el-tab-pane label="Transaction Report" name="TransactionReport">
          <rabbey-table3
            ref="companyTable"
            :border="true"
            :stripe="true"
            :columns="Columns"
            v-loading="loading_transaction_report"
            :data="transactions"
            :pageSizes="[10, 20, 50, 100, 200, 500]"
          />
        </el-tab-pane>
        <el-tab-pane label="Por clientes" name="cl">
          <rabbey-table3
            ref="cl"
            :border="true"
            :stripe="true"
            :columns="ColumnsTCustomer"
            v-loading="loading1"
            :data="dataApi"
            :pageSizes="[10, 20, 50, 100, 200, 500]"
          />
        </el-tab-pane>
        <el-tab-pane label="Por proveedores" name="pr">
          <rabbey-table3
            ref="pr"
            :border="true"
            :stripe="true"
            :columns="ColumnsTProveedores"
            v-loading="loading1"
            :data="dataApi"
            :pageSizes="[10, 20, 50, 100, 200, 500]"
          />
        </el-tab-pane>
        <el-tab-pane label="Por tipos de transacciones" name="tr">
          <rabbey-table3
            ref="tr"
            :border="true"
            :stripe="true"
            :columns="ColumnsTransactiType"
            v-loading="loading1"
            :data="dataApi"
            :pageSizes="[10, 20, 50, 100, 200, 500]"
          />
        </el-tab-pane>
        <el-tab-pane label="Transacciones Por Dias" name="dia">
          <rabbey-table3
            ref="dia"
            :border="true"
            :stripe="true"
            :columns="ColumnsTransactiDay"
            v-loading="loading1"
            :data="dataApi"
            :pageSizes="[10, 20, 50, 100, 200, 500]"
          />
        </el-tab-pane>
        <el-tab-pane label="Transacciones Por Horas" name="horT">
          <rabbey-table3
            ref="hor"
            :border="true"
            :stripe="true"
            :columns="ColumnsTransactiHours"
            v-loading="loading1"
            :data="dataApi"
            :pageSizes="[10, 20, 50, 100, 200, 500]"
          />
        </el-tab-pane>
        <el-tab-pane label="Transacciones Por minutos" name="min">
          <rabbey-table3
            ref="min"
            :border="true"
            :stripe="true"
            :columns="ColumnsTransactiminutos"
            v-loading="loading1"
            :data="dataApi"
            :pageSizes="[10, 20, 50, 100, 200, 500]"
          />
        </el-tab-pane>

        <el-tab-pane label="Grafico de Transacciones" name="chartyer">
          <el-tabs
            v-model="activeName2"
            :tab-position="tabPosition"
            @tab-click="switchtabs"
            style="height: 770px"
          >
            <el-tab-pane label="Por Año" name="chartyer">
              <div
                style="background-color:#f3f7fa; top:20px
                   width:10px; height:30px; position:relative; right:27px; 
                   border-radius:14px; bottom: 78px;
                   "
              >
                <h3 style="position: relative; left: 35px">
                  Grafica de Transacciones Por año:{{ year }}
                </h3>
              </div>
              <IEcharts
                :option="bar"
                :loading="loading1"
                style="
                  width: 1350px;
                  height: 450px;
                  border-radius: 14px;
                  margin: 10px;
                  position: relative;
                  right: 70px;
                  background-color: #f3f7fa;
                "
              />
            </el-tab-pane>
            <el-tab-pane label="Por Mes" name="chartdia">
              <div
                style="background-color:#f3f7fa; top:20px
                   width:10px; height:30px; position:relative; right:27px; 
                   border-radius:14px; bottom: 78px;
                   "
              >
                <h3 style="position: relative; left: 35px">
                  Grafica de Transacciones Por Mes: {{ mes }}/{{ year }}
                </h3>
              </div>
              <IEcharts
                :option="bar"
                :loading="loading1"
                style="
                  width: 1350px;
                  height: 450px;
                  border-radius: 14px;
                  margin: 10px;
                  position: relative;
                  right: 70px;
                  background-color: #f3f7fa;
                "
              />
            </el-tab-pane>
            <el-tab-pane label="Por Dia" name="pmhor">
              <div
                style="background-color:#f3f7fa; top:20px
                   width:10px; height:30px; position:relative; right:27px; 
                   border-radius:14px; bottom: 78px;
                   "
              >
                <h3 style="position: relative; left: 35px">
                  Grafica de Transacciones Por Dia: {{ dia }}/{{ mes }}/{{
                    year
                  }}
                </h3>
              </div>
              <IEcharts
                :option="bar"
                :loading="loading1"
                style="
                  width: 1350px;
                  height: 450px;
                  border-radius: 14px;
                  margin: 10px;
                  position: relative;
                  right: 70px;
                  background-color: #f3f7fa;
                "
              />
            </el-tab-pane>
            <el-tab-pane label="Por Hora" name="pmmin">
              <div
                style="background-color:#f3f7fa; top:20px
                   width:10px; height:30px; position:relative; right:27px; 
                   border-radius:14px; bottom: 78px;
                   "
              >
                <h3 style="position: relative; left: 35px">
                  Grafica de Transacciones Por Hora: {{ valueH }}:{{ minutos }}
                  {{ dia }}/{{ mes }}/{{ year }}
                </h3>
              </div>
              <IEcharts
                :option="bar"
                :loading="loading1"
                style="
                  width: 1350px;
                  height: 450px;
                  border-radius: 14px;
                  margin: 10px;
                  position: relative;
                  right: 70px;
                  background-color: #f3f7fa;
                "
              />
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { Columns } from "./columnsTables/TransactionReportColumns";
import IEcharts from "vue-echarts-v3/src/full.js";
import {
  ColumnsTCustomer,
  ColumnsTransactiDay,
  ColumnsTProveedores,
  ColumnsTransactiType,
  ColumnsTransactiHours,
  ColumnsTransactiminutos
} from "./columnsTables/TransactionForCustomerCo";
import { mapState } from "vuex";

export default {
  name: "TransactionReport",
  components: {
    IEcharts
  },
  created: async function () {
    this.$store.dispatch("getTransactionReport");
  },
  data() {
    return {
      activeName: "TransactionReport",
      activeName2: "chartyer",
      minutos: new Date().getMinutes(),
      valueH: new Date().getHours(),
      dia: new Date().getDate(),
      mes: new Date().getMonth() + 1,
      valueM: new Date().getMinutes(),
      year: new Date().getFullYear(),
      dataApi: [],
      options: "",
      value5: "",
      loading1: false,
      declinedOption: null,
      tabPosition: "left",
      Columns,
      ColumnsTCustomer,
      ColumnsTProveedores,
      ColumnsTransactiType,
      ColumnsTransactiDay,
      ColumnsTransactiHours,
      ColumnsTransactiminutos,
      search: "",
      declined: null,
      newOption: null,
      meses: [
        { Label: "Enero", Value: 1 },
        { Label: "Febrero", Value: 2 },
        { Label: "Marzo", Value: 3 },
        { Label: "Abril", Value: 4 },
        { Label: "Mayo", Value: 5 },
        { Label: "Junio", Value: 6 },
        { Label: "Julio", Value: 7 },
        { Label: "Agosto", Value: 8 },
        { Label: "septiembre", Value: 9 },
        { Label: "octubre", Value: 10 },
        { Label: "Noviembre", Value: 11 },
        { Label: "Diciembre", Value: 12 }
      ],
      dias: [
        { Label: "1", Value: 1 },
        { Label: "2", Value: 2 },
        { Label: "3", Value: 3 },
        { Label: "4", Value: 4 },
        { Label: "5", Value: 5 },
        { Label: "6", Value: 6 },
        { Label: "7", Value: 7 },
        { Label: "8", Value: 8 },
        { Label: "9", Value: 9 },
        { Label: "10", Value: 10 },
        { Label: "11", Value: 11 },
        { Label: "12", Value: 12 },
        { Label: "13", Value: 13 },
        { Label: "14", Value: 14 },
        { Label: "15", Value: 15 },
        { Label: "16", Value: 16 },
        { Label: "17", Value: 17 },
        { Label: "18", Value: 18 },
        { Label: "19", Value: 19 },
        { Label: "20", Value: 20 },
        { Label: "21", Value: 21 },
        { Label: "22", Value: 22 },
        { Label: "23", Value: 23 },
        { Label: "24", Value: 24 },
        { Label: "25", Value: 25 },
        { Label: "26", Value: 26 },
        { Label: "27", Value: 27 },
        { Label: "28", Value: 28 },
        { Label: "29", Value: 29 },
        { Label: "30", Value: 30 },
        { Label: "31", Value: 31 }
      ],
      // newOptions: [
      //   {
      //     value: true,
      //     label: "2020"
      //   },
      //   {
      //     value: true,
      //     label: "2021"
      //   },
      //   {
      //     value: true,
      //     label: "2022"
      //   },
      //   {
      //     value: true,
      //     label: "2023"
      //   }
      // ],
      declinedOptions: [
        {
          value: null,
          label: "Todos"
        },
        {
          value: false,
          label: "Exitosas"
        },
        {
          value: true,
          label: "Rechazadas"
        }
      ],
      bar: {
        title: {
          text: ""
        },
        tooltip: {},
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [
          {
            name: "Cantidad de Transacciones",
            type: "line",
            data: []
          },
          {
            name: "",
            type: "line",
            data: []
          }
        ]
      }
    };
  },
  methods: {
    onDeclinedChanging() {
      this.$store.dispatch("getTransactionReport", this.declinedOption);
      //console.log("getTransactionReport");
    },
    GetTransactionAumount() {
      this.loading1 = true;
      this.$http
        .get(
          `/api/tennos/GetTransactionAumount?options=${this.options}&year=${this.year}&Month=${this.mes}&day=${this.dia}`
        )
        .then((resp) => {
          this.dataApi = resp.data;
          // console.log("data api", this.dataApi);
          // if(this.options == "dia"){
          //   const dias =  resp.data.map(d=> d.Dia)
          //   this.bar.xAxis.data = dias;
          //   console.log('los dias mios',dias)
          // }
          if (this.options == "hor") {
            const Hora = resp.data.map((h) => h.Hora);
            this.bar.xAxis.data = Hora;
            // console.log("las hora mios", Hora);
          } else if (this.options == "chartyer") {
            const month = resp.data.map((m) => m.MesGra);
            this.bar.xAxis.data = month;
            // console.log("los meses mios", month);
          }
          //  else if(this.options == "dia"){
          //   const Dia1 =  resp.data.map(d=> d.Dia)
          //    this.bar.xAxis.data = Dia1;
          //    console.log('los meses mios',Dia)
          //  }
          else if (this.options == "chartdia") {
            const Dia = resp.data.map((d) => d.Dia);
            this.bar.xAxis.data = Dia;
            // console.log("los meses mios", Dia);
          } else {
            //minuto
            const minutos = resp.data.map((m) => m.minuto);
            this.bar.xAxis.data = minutos;
            // console.log("los minutos mios", minutos);
          }
          this.bar.series[0].data = Object.values(
            resp.data.map((t) => t.transactions)
          );
          // console.log("klk data dame luz", resp.data);
          // console.log("klk data", this.dataApi);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    switchtabs(activeName) {
      switch (activeName.name) {
        case "TransactionReport": {
          this.options = "TransactionReport";
          break;
        }
        case "cl": {
          this.options = "cl";
          this.GetTransactionAumount();
          break;
        }
        case "pr": {
          this.options = "pr";
          this.GetTransactionAumount();
          break;
        }
        case "tr": {
          this.options = "tr";
          this.GetTransactionAumount();
          break;
        }

        case "dia": {
          this.options = "chartdia";
          this.GetTransactionAumount();
          break;
        }
        case "horT": {
          this.options = "horT";
          this.GetTransactionAumount();
          break;
        }
        case "min": {
          this.options = "min";
          this.GetTransactionAumount();
          break;
        }
        case "pmhor": {
          this.options = "hor";
          // this.bar.xAxis.data = this.dias;
          this.GetTransactionAumount();
          break;
        }
        case "chartdia": {
          this.options = "chartdia";
          this.GetTransactionAumount();
          break;
        }
        case "pmmin": {
          this.options = "min";
          this.GetTransactionAumount();
          break;
        }
        case "chartyer": {
          this.options = "chartyer";
          this.GetTransactionAumount();
          break;
        }
      }
    },
    handlerYearChange(year) {
      this.year = year;
      this.GetTransactionAumount();
    }
  },
  watch: {
    mes() {
      this.GetTransactionAumount();
    },
    dia() {
      this.GetTransactionAumount();
    },
    valueH() {
      this.GetTransactionAumount();
    }
  },
  computed: {
    ...mapState({
      loading_transaction_report: (state) =>
        state.ncfmovil.loading_transaction_report,
      transactions: (state) => state.ncfmovil.transactions
    }),

    yearsearch() {
      const lowLevel = 2014;
      const currentYear = new Date().getFullYear() + 5;
      let Years = [];
      for (var i = lowLevel; i <= currentYear; i++) {
        Years.push({ label: i, value: i });
      }
      return Years;
    }
  }
};
</script>

<style scoped></style>
